export default {
  loggingEnabled: false,
  fieldsetClassName: 'tn-bridge-fieldset',
  legendClassName: 'tn-bridge-legend',
};
